// extracted by mini-css-extract-plugin
export default {"groups":"Stack_groups__bCICe","group":"Stack_group__nRQik"};